<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b1" id="dec1"><a href="#/Text/contents#dec">DEDICATION</a></h2>
<p class="center1-o"><span>To Siny Widmer and Arie Baak<br/>
  dear friends and colleagues who have shared my journey</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6e890ca9